import apiClient from "./client";

export const getCourses = async ({ language = "en" } = {}) => {
  const response = await apiClient.get("/courses", {
    params: { language },
  });
  return response.data;
};

export const getCourseById = async ({ id, language = "en" }) => {
  const response = await apiClient.get(`/courses/${id}`, {
    params: { language },
  });
  return response.data;
};
